<template>
  <div>
    <div class="card-content"
      style="padding:0px;background-image: -webkit-gradient(linear, left top, left bottom, from(rgba(255, 225, 0, .25)), to(rgba(255, 225, 0, 0)));background-image: linear-gradient(180deg, rgba(255, 225, 0, .25), rgba(255, 225, 0, 0));">

      <div class="title">
        <h2>ヤギプライムでAI機能を<span><a href="/yagiprimeinfo" target="_blank" class="notelink-icon">？</a></span></h2>
      </div>

      <p>Yagishの<a href="/terms" id="footer-link-terms" target="_blank">利用規約</a>、<a href="/privacy"
          id="footer-link-terms" target="_blank">個人情報の取り扱いについて</a>、<img
          src="/static/renew3_img/carat_img/caratcheck_icon.svg" alt="チェック" class="check_icon" style="">
        <a href="/yagiprimeterms" target="_blank">ヤギプライム利用規約</a>に同意の上、ヤギプライムにご登録ください。
      </p>
      <p class="red_color">*AI履歴書の本格的な利用にはヤギプライム登録が必要です。</p>

      <PaymentForm class="wrapper_payment" v-if="!$globalVar.isYagiPrime" :serviceName="serviceName" :price="price" :is_subscription="true" />

      <div class="edit-form-item" v-else>
        あなたはすでにヤギプライムのユーザーです。
      </div>
    </div>
  </div>
</template>

<script>
import PaymentForm from '@/components/Payment/PaymentMethodSelector.vue'

export default {
  components: {
    PaymentForm
  },
  data: function () {
    return {
      serviceName: 'ヤギプライム',
      price: 550
    }
  }
}
</script>

<style scoped>
.check_icon {
  position: relative;
  height: 16px;
  top: -5px;
}
.title {
  font-size: 1.3rem;
  font-weight: bold;
  margin: 10px 0;
}
.notelink-icon {
  display: inline-block;
  position: relative;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #404040;
  color: #fff;
  text-align: center;
  line-height: 20px;
  margin-left: 5px;
  font-size: 0.8rem;
  bottom: 2px;
}
.red_color {
  color: #E3165C;
}
.wrapper_payment {
  margin-top: 15px;
}
</style>
